module.exports = __webpack_public_path__ + "assets/fwa-feb8131b3295031d8a39798bd8ee18fa.svg";